import React from 'react';
import TabelaListagem from '../../../../components/TabelaListagem/TabelaListagem';
export default function TabelaRotasDeColeta({ items = [], actions }) {
    const headers = [
        { value: "Rota", objectValue: "descricao" },
        { value: "Veiculo", objectValue: "veiculo" },
        { value: "Destino", objectValue: "destino" },
        { value: "Total de geradores", objectValue: "totalGeradores" },
        { value: "Modalidade de coleta", objectValue: "modalidade" },
        { value: "Status", objectValue: "status" },
    ]
    return (
        <TabelaListagem actions={actions} title='Lista de rotas de coletas' headers={headers} items={items} options={{ print: false, search: true, pagination: true }} />
    );
}